/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreamingMode } from './StreamingMode';
import {
    StreamingModeFromJSON,
    StreamingModeFromJSONTyped,
    StreamingModeToJSON,
    StreamingModeToJSONTyped,
} from './StreamingMode';

/**
 * 
 * @export
 * @interface UpdateStreamingSettingsBody
 */
export interface UpdateStreamingSettingsBody {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStreamingSettingsBody
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStreamingSettingsBody
     */
    allowParticipantStreams?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStreamingSettingsBody
     */
    discoverableInLiveHub?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStreamingSettingsBody
     */
    requireApproval?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateStreamingSettingsBody
     */
    showViewerCounts?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateStreamingSettingsBody
     */
    maxFeaturedStreams?: number;
    /**
     * 
     * @type {StreamingMode}
     * @memberof UpdateStreamingSettingsBody
     */
    streamingMode?: StreamingMode;
}



/**
 * Check if a given object implements the UpdateStreamingSettingsBody interface.
 */
export function instanceOfUpdateStreamingSettingsBody(value: object): value is UpdateStreamingSettingsBody {
    return true;
}

export function UpdateStreamingSettingsBodyFromJSON(json: any): UpdateStreamingSettingsBody {
    return UpdateStreamingSettingsBodyFromJSONTyped(json, false);
}

export function UpdateStreamingSettingsBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStreamingSettingsBody {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'allowParticipantStreams': json['allowParticipantStreams'] == null ? undefined : json['allowParticipantStreams'],
        'discoverableInLiveHub': json['discoverableInLiveHub'] == null ? undefined : json['discoverableInLiveHub'],
        'requireApproval': json['requireApproval'] == null ? undefined : json['requireApproval'],
        'showViewerCounts': json['showViewerCounts'] == null ? undefined : json['showViewerCounts'],
        'maxFeaturedStreams': json['maxFeaturedStreams'] == null ? undefined : json['maxFeaturedStreams'],
        'streamingMode': json['streamingMode'] == null ? undefined : StreamingModeFromJSON(json['streamingMode']),
    };
}

export function UpdateStreamingSettingsBodyToJSON(json: any): UpdateStreamingSettingsBody {
    return UpdateStreamingSettingsBodyToJSONTyped(json, false);
}

export function UpdateStreamingSettingsBodyToJSONTyped(value?: UpdateStreamingSettingsBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'allowParticipantStreams': value['allowParticipantStreams'],
        'discoverableInLiveHub': value['discoverableInLiveHub'],
        'requireApproval': value['requireApproval'],
        'showViewerCounts': value['showViewerCounts'],
        'maxFeaturedStreams': value['maxFeaturedStreams'],
        'streamingMode': StreamingModeToJSON(value['streamingMode']),
    };
}

